import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { RoleModalComponent } from '../role-modal/role-modal.component';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { UpdateRoleComponent } from '../update-role/update-role.component';


@Component({
  selector: 'app-role-management',
  templateUrl: './role-management.component.html',
  styleUrls: ['./role-management.component.css'],
  standalone: false
})
export class RoleManagementComponent implements OnInit{
  action_idx: any = null;

  roles: any[] = [];

  privileges: any[] = [];

  form: FormGroup;

  isSearching: boolean = false;

  showSearchForm: boolean = false;
  searchedRoleNotFound = false;
  isEmpty!: boolean;
  searched = false;
  isLoading: boolean = false;
  selectedStatus!: boolean;

  isDarkMode!: boolean;

  page: number = 0;
  num: number = 1;
  currentPage: number = 1;
  count: number = 0;
  pageSize: number = 10;
  selectedLimit: number = 10;



  constructor(
    public fb: FormBuilder,
    private apiService: ApiService,
    public dialog: MatDialog,

  ) { };


  toggleShowSearch() {
    this.showSearchForm = !this.showSearchForm
  }





  ngOnInit(): void {

    this.form = this.fb.group({
      name: [''],
      status: [''],
      description: [''],
      privilegeId: [''],
      offset: [''],
    });

    this.getAllPrivileges()
    this.search()

  }

  getAllPrivileges() {
    this.isLoading = true;
    this.apiService
      .get('/privileges/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.privileges = response.data.map((priv) => ({
          ...priv,
          formattedPermission: this.toTitleCase(priv.permission.replace(/_/g, ' ')),
        }));
      });
  }

  toTitleCase(str: string): string {
    return str
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }


  openDeleteConfirmModal(id: number, name: string) {

    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: "Confirm delete role: " + name + "?",
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

          this.deleteRole(id)

        },
        onCancel: () => {

        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });

}


activateRole(id: number): void {

  this.isLoading = true
  this.apiService
    .get(`/roles/activate/${id}`)
    .pipe(
      finalize(() => {
        this.isLoading = false;
      })
    )
    .subscribe(
      (response: any) => {

        this.openSuccessModal('Role activated successfuly');
      },
      (error) => {
        this.openErrorModal(error?.message)
      }
    );

}

  openDeactivateConfirmModal(id: number, name: string) {

    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: "Confirm deactivating role: " + name + "?",
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

          this.deactivateRole(id)

        },
        onCancel: () => {

        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });

}

deactivateRole(id: number): void {

  this.isLoading = true
  this.apiService
    .get(`/roles/deactivate/${id}`)
    .pipe(
      finalize(() => {
        this.isLoading = false;
      })
    )
    .subscribe(
      (response: any) => {

        this.openSuccessModal('Role deactivated successfuly');
      },
      (error) => {
        this.openErrorModal(error?.message)
      }
    );

}

  openActivateConfirmModal(id: number, name: string) {

    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: "Confirm activating role: " + name + "?",
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {

          this.activateRole(id)

        },
        onCancel: () => {

        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });

}

deleteRole(id: number): void {

  this.isLoading = true
  this.apiService
    .get(`/roles/delete/${id}`)
    .pipe(
      finalize(() => {
        this.isLoading = false;
      })
    )
    .subscribe(
      (response: any) => {

        this.openSuccessModal('Role deleted successfuly');
      },
      (error) => {
        this.openErrorModal(error?.message)
      }
    );

}


openSuccessModal(message: string) {
  let dialogRef = this.dialog.open(SuccessModalComponent, {
    width: '350px',
    backdropClass: 'modal-form-backdrop',
    hasBackdrop: true,
    panelClass: ['modal-form', 'modal-no-overflow-changed'],
    data: { successMessage: message },
  });

  dialogRef.afterClosed().subscribe(() => {
    location.reload();
  });
}

openErrorModal(message: string) {
  let dialogRef = this.dialog.open(ErrorModalComponent, {
    width: '350px',
    backdropClass: 'modal-form-backdrop',
    hasBackdrop: true,
    panelClass: ['modal-form', 'modal-no-overflow-changed'],
    data: { errorMessage: message },
  });

  dialogRef.afterClosed().subscribe(() => {

  });
}

  updateLimit() {

    this.currentPage = 1;

    this.page = 0;

    this.search()
  }

  search() {

    this.roles = []

    this.searchedRoleNotFound = false;
    this.isSearching = true;

    this.num = this.page * this.selectedLimit;

    var formData: any = new FormData();

    this.pageSize = this.selectedLimit

    formData.append("offset", this.num);
    formData.append("limit", this.selectedLimit);
    formData.append("name", this.form.get('name')?.value || '');
    formData.append("description", this.form.get('description')?.value || '');
    formData.append("status", this.form.get('status')?.value || '');
    formData.append("privilegeId", this.form.get('privilegeId')?.value || '');

    this.apiService
      .post('/roles/page', formData)
      .pipe(
        finalize(() => {
          this.isSearching = false;
          this.isLoading = false;
        })
      )
      .subscribe(
        (response) => {

          this.roles = response.data;

          this.count = response.totalElements;

          if (this.count == 0) {
            this.searchedRoleNotFound = true;
          }
        },
        (error) => {

          this.openErrorModal(error?.message)

          this.searchedRoleNotFound = true;
        }
      );
  }


  splitPriviledges(privileges: String): string[] {
    return privileges?.split(',').map((item) => item.trim());
  }

  openDialogRef(data?: any) {
    let dialogRef = this.dialog.open(RoleModalComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', ],
      disableClose: true,

      data,
    });

    return dialogRef;
  }

  createRole() {

    let dialogRef = this.openDialogRef();

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.search();
      }
    });
  }

  openEditDialogRef(data?: any) {
    let dialogRef = this.dialog.open(UpdateRoleComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      disableClose: true,

      panelClass: ['modal-form', ],
      data,
    });

    return dialogRef;
  }


  editRole(role: any) {

    let dialogRef = this.openEditDialogRef(role);

    dialogRef.afterClosed().subscribe((result) => {

      if (result) {
        this.search();
      }
    });
  }

  callDb(event: any) {
    this.currentPage = event;

    this.page = event - 1;

    this.search();
  }


}
